.header {
  display: flex;
  align-items: center;
  gap: var(--hcr-spacing-2);
  // Honeycomb PanelHeader lays its title out as a block; normalise line-height
  // so the avatar, name and pill share one centred baseline.
  line-height: 1;
}

.headerTitle {
  font-weight: bold;
  line-height: 1;
  margin: 0;
}

// Tint + circular clip. Padding keeps the cover-sized sparkle inside the circle.
.headerAvatar {
  background-color: var(--hcr-highlight-color);
  flex: 0 0 auto;
  color: var(--hcr-ui-primary-color);
  border-radius: 50%;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--hcr-spacing-1);
}
